export { logger, setInstance } from './logger';
export * from './shared';
if (typeof window === 'undefined' && process.env.NEXT_RUNTIME !== 'edge') {
  import('../server-logging');
}
